// extracted by mini-css-extract-plugin
export default {"title":"FamilyPlanning_title__uJMiZ","readingInput":"FamilyPlanning_readingInput__oq0+S","readingsRow":"FamilyPlanning_readingsRow__cUYph"};